export const CURRENT_LOCATION_LABEL = 'Use Current Location';
